export default "__VITE_ASSET__CRjpxX6g__"